module.exports = __webpack_public_path__ + "img/trends_9.0e535560.jpg";